<template>
  <section class="Objectives" id="Objectives">
    <div class="objectives_wrapper">
      <div class="title light" id="objectives_title">
        <span>
          Objetivos
        </span>
      </div>
      <div class="objectives_list">
        <ul>
          <li v-for="(item, i) in list" :key="i">
            <span></span>
            <p>
              {{ item.text }}
            </p>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data: () => ({
    list: [
      {
        text: "Lograr permanencia y sostenibilidad de la institución en el corto, mediano y largo plazo con una oferta de valor que dé respuesta a las necesidades y expectativas de los clientes actuales y potenciales a través de la implementación del PEI y el plan estratégico apuntando a la misión Cayrina."
      },
      {
        text: "Forjar una cultura ambiental Cayrina, para la comprensión de las problemáticas ambientales del entorno, a través de la construcción de proyectos que redunden en beneficio de las actitudes y de los valores de cada uno de los miembros de la comunidad educativa, en el marco, de una formación ética y responsable frente al manejo adecuado del entorno."
      },
      {
        text: "Desarrollar el talento humano de los empleados, desde la vinculación hasta el retiro, con la implementación de prácticas laborales, capacitación y de bienestar que den respuesta a las necesidades y expectativas de las partes interesadas, apuntando a la mejora en la prestación del servicio ofrecido por la institución."
      },
      {
        text: "Gestionar los recursos institucionales garantizando el desarrollo de la propuesta educativa favoreciendo la sostenibilidad y el desarrollo de la estrategia, atendiendo a los cambios y necesidades internos y externos."
      },
      {
        text: "Desarrollar en los estudiantes las competencias propuestas por el Ministerio de Educación con un plan de estudios actualizado que posibilite la formación de personas íntegras y que aporten a la sociedad."
      },
      {
        text: "Promover el liderazgo, la sana convivencia, el acompañamiento integral y la formación en valores cristianos, con todos los agentes de la educación."
      }
    ]
  }),
  mounted () {
    // window.addEventListener('scroll', () => {
    //   const objectives = document.getElementById('Objectives')
    //   let top = document.documentElement.scrollTop
    //   let height = document.documentElement.clientHeight

    //   if ( top + (height / .7) > objectives.offsetTop + (objectives.clientHeight / 2) ) {
    //     objectives.classList.add('trigger')
    //   }
    // })
      // header.classList.add('trigger')
  }
}
</script>

<style lang="sass">
@import '../assets/css/app.sass'
.Objectives
  width: 980px
  margin: 0 auto
  padding: 7rem 70px
  box-sizing: border-box
  .objectives_wrapper
    display: grid
    grid-template-columns: 1fr
    grid-gap: 80px
    .title
      position: relative
      height: 30px
      span
        position: absolute
        left: 0
        top: 0
        transition: all ease-in-out .3s .5s
      &:after
        content: ''
        position: absolute
        width: 100%
        height: 100%
        background-color: white
        left: 0
        top: -30px
    .objectives_list
      ul
        display: grid
        grid-template-columns: repeat(auto-fill, minmax(350px, 1fr))
        grid-gap: 40px
        li
          margin-bottom: 1.5rem
          &:last-child
            margin-bottom: 0
          &:nth-child(3n+1)
            span
              background-color: $accent_secondary_color
          &:nth-child(3n+2)
            span
              background-color: $secondary_color
          span
            display: flex
            justify-content: center
            align-items: center
            width: 12px
            height: 12px
            background-color: $accent_color
            margin-bottom: 5px
          p
            color: $primary_color
            font-family: $font_text
            font-size: 14px
            line-height: 1.7
            opacity: 0.8
            transition: all ease-in-out .5s .6s

@media screen and (max-width: 980px)
  .Objectives
    width: 760px
    padding: 5rem 70px
    .objectives_wrapper
      grid-template-columns: 1fr
      .objectives_list
        ul
          grid-template-columns: repeat(auto-fill, minmax(250px, 1fr))
          li
            margin-bottom: 1rem
            p
              font-size: 13px

@media screen and (max-width: 760px)
  .Objectives
    width: 480px
    padding: 5rem 0
    .objectives_wrapper
      grid-template-columns: 1fr
      .objectives_list
        ul
          li
            margin-bottom: .7rem

@media screen and (max-width: 560px)
  .Objectives
    width: 320px
    .objectives_wrapper
      grid-template-columns: 1fr
      .objectives_list
        ul
          grid-template-columns: 1fr
          li
            margin-bottom: .5rem

@media screen and (max-width: 400px)
  .Objectives
    width: 100%
    padding:
      left: 40px
      right: 40px
    box-sizing: border-box
    .objectives_wrapper
      grid-gap: 60px
</style>